import { render, staticRenderFns } from "./static-blocks.vue?vue&type=template&id=aae1f71e&scoped=true"
import script from "./static-blocks.vue?vue&type=script&lang=js"
export * from "./static-blocks.vue?vue&type=script&lang=js"
import style0 from "./static-blocks.vue?vue&type=style&index=0&id=aae1f71e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aae1f71e",
  null
  
)

export default component.exports